<template>
  <section id="top" class="mt-12">
    <v-container fluid class="text-center">
      <div v-if="isMobile" class="mt-12">
        <span class="font-weight-black black--text custom-font headline">
          BUILDING
        </span>
        <span class="font-weight-black red--text custom-font headline">
          MAINTENANCE
        </span>
      </div>
      <!-- Hero Image with Overlay Text -->
      <v-img
        src="@/assets/ems_images/building_services.webp"
        height="300"
        dark
        class="mt-10"
        gradient="to bottom, rgba(0,0,0, .1), rgba(0,0,0, .7)"
      >
      </v-img>
    </v-container>
    <v-container class="text-center">
      <span
        :class="[$vuetify.breakpoint.smAndDown ? 'headline' : 'display-2']"
        class="font-weight-black black--text custom-font"
      >
        OUR
      </span>
      <span
        :class="[$vuetify.breakpoint.smAndDown ? 'headline' : 'display-2']"
        class="font-weight-black red--text custom-font"
      >
        SERVICES
      </span>
      <v-responsive
        class="my-10 mx-auto title font-weight-light mb-8"
        max-width="720"
        >Our Maintenance Services deliver an all-encompassing approach to
        building upkeep. From relief superintendents to expert cleaners, we
        ensure prompt, efficient care for your facilities. Our responsive team
        is equipped to meet urgent demands, guaranteeing that your property is
        consistently in pristine condition.
      </v-responsive>
      <!-- Services List -->
      <v-row class="mt-5">
        <v-col
          v-for="({ icon, title, text }, i) in services"
          :key="i"
          cols="12"
          md="4"
        >
          <!-- Updated Card Styling -->
          <v-card
            height="300"
            class="py-12 px-4"
            color="grey lighten-3"
            flat
            elevation="2"
          >
            <v-theme-provider dark>
              <div class="my-1">
                <v-avatar color="black" size="60">
                  <v-icon color="red" large v-text="icon"></v-icon>
                </v-avatar>
              </div>
            </v-theme-provider>
            <v-card-title
              class="justify-center font-weight-bold text-uppercase black--text no-wrap-class subtitle-1"
              v-text="title"
            ></v-card-title>

            <v-card-text class="body-1 black--text" v-html="text"></v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>




<script>
import { mapGetters } from "vuex";
export default {
  name: "BuildingMaintenanceServicesPage",
  components: {},
  computed: {
    ...mapGetters(["isMobile"]),
  },
  data() {
    return {
      services: [
        {
          icon: "mdi-account-tie", // Assuming icon for "Cleaners"
          title: "Cleaners",
          text: "Contract & Temp services to ensure your facilities are impeccably maintained.",
        },
        {
          icon: "mdi-account-hard-hat", // Assuming icon for "Superintendents"
          title: "Superintendents",
          text: "Professional and experienced staff available for both contract and temporary assignments.",
        },
        {
          icon: "mdi-vacuum", // This icon is appropriate for "Carpet Cleaning & Installation"
          title: "Carpet Cleaning & Installation",
          text: "Expert carpet cleaning and installation services for pristine and durable flooring.",
        },
        {
          icon: "mdi-grid", // Assuming icon for "Tile Restoration & Installation"
          title: "Tile Restoration & Installation",
          text: "High-quality tile work, from restoration to new installations, crafted to perfection.",
        },
        {
          icon: "mdi-hazard-lights", // Assuming icon for "Asbestos Removal & Mould Remediation"
          title: "Asbestos Removal & Mould Remediation",
          text: "Specialized services to safely remove asbestos and remediate mould for a healthier environment.",
        },
        {
          icon: "mdi-water-pump", // Assuming icon for "Flood Remediation"
          title: "Flood Remediation",
          text: "Emergency 24/7 response for flood damage control and remediation services.",
        },
        {
          icon: "mdi-home-modern", // Assuming icon for "Renovations & Construction"
          title: "Renovations & Construction",
          text: "Transforming spaces with our comprehensive renovation and construction services.",
        },
        {
          icon: "mdi-spray-bottle", // Assuming icon for "Power Washing & Drain Cleaning"
          title: "Power Washing & Drain Cleaning",
          text: "High-power cleaning solutions for drains and surfaces to restore their original state.",
        },
        {
          icon: "mdi-brush", // Assuming icon for "Painting & Graffiti Removal"
          title: "Painting & Graffiti Removal",
          text: "Professional painting services and efficient removal of graffiti to enhance property aesthetics.",
        },
        {
          icon: "mdi-wrench", // Assuming icon for "Property Maintenance"
          title: "Property Maintenance",
          text: "Comprehensive maintenance services to ensure your property is managed efficiently.",
        },
        // Add any additional services here
      ],
    };
  },
};
</script>

<style scoped>
.no-wrap-class {
  word-break: keep-all;
  hyphens: manual;
}
</style>
